import { useTranslation } from 'react-i18next';

import type { Publication } from '~/interfaces/publication';

import useEmail from '~/hooks/useEmail';

interface Props {
  isSignupFlowInProgess: boolean;
  publication: Publication;
}

export default function Header(props: Props) {
  const { t } = useTranslation();
  const [email] = useEmail();

  return (
    <div className="flex flex-col space-y-4" suppressHydrationWarning>
      <div className="mb-4 flex flex-col space-y-1">
        <h1 className="text-left text-xl font-bold text-gray-900">
          {email ? `${t('recommendations.suggestion')}` : t('recommendations.title')}
        </h1>

        {!props.isSignupFlowInProgess ? (
          <p className="text-sm text-left text-gray-700">{props.publication.name} also recommends these newsletters.</p>
        ) : (
          <p className="text-sm text-left text-gray-700">
            {props.publication.web_template.signup_flow_messaging.recommendations_message
              ? props.publication.web_template.signup_flow_messaging.recommendations_message
              : `${props.publication.name} also recommends these newsletters.`}
          </p>
        )}
      </div>
    </div>
  );
}
